const Form054SC = {
    stepName: {
        Statement: "重要事项",
        SelectForm: "选择「治疗师现金津贴」",
        SchoolInfo: "基本资料",
        SelectPart: "选择甲部／乙部",
        SectionA: "甲部",
        SectionB: "乙部",
        Certification: "声明",
        Confirmation: "确认",
    },
    label: {
        applyFormOption: {
            CGOT: "资助特殊学校「职业治疗师现金津贴」",
            CGPT: "资助特殊学校「物理治疗师现金津贴」",
            CGST: "资助特殊学校「言语治疗师现金津贴」",
        },
        applyPartOption: {
            PartA: "甲部 以一／两个{{fullName}}的空缺职位换取「津贴」",
            PartB: "乙部 以「津贴」代替{{fullName}}放取不少于30天核准假期的临时补缺人员安排",
        },
        NROption: {
            N: "新申领津贴的职位",
            R: "修订的申领",
        },
        changePreClaimOption: {
            unDelete: "不更改先前声明",
            delete: "删除先前声明",
            change: "更改先前声明",
        },
        OTRankOption: {
            SOT: "高级职业治疗师",
            OTI: "一级职业治疗师",
        },
        OTRankOptionPartB: {
            SOT: "高级职业治疗师",
            OTI: "一级职业治疗师",
            OTII: "二级职业治疗师",
        },
        PTRankOption: {
            SPT: "高级物理治疗师",
            PTI: "一级物理治疗师",
        },
        PTRankOptionPartB: {
            SPT: "高级物理治疗师",
            PTI: "一级物理治疗师",
            PTII: "二级物理治疗师",
        },
        salaryList: {
            pt34: "74515",
            pt25: "51095",
            pt19: "38595",
            pt26: "53500",
        },
        shortName: {
            CGOT: "职业治疗师",
            CGPT: "物理治疗师",
            CGST: "言语治疗师",
        },
        rankOption: {
            CGOT: "和职级",
            CGPT: "和职级",
            CGST: "职级",
        },

        termsConditions: "我已阅读、理解并同意上述条款和条件。",
        statementTwo: "本人理解申请人和教师需要拥有「智方便+」帐户才能处理申请。",
        statement: "个人资料收集声明",
        applyTitle: "请选择：",
        noteTitle: "注",
        previousDate: "前次申领表格日期：",
        headerTitleOne: "基本资料",
        headerTitleTwo: "以一／两个{{postName}}的空缺职位换取「津贴」",
        head1: "致 ：",
        head2: "教育局经常津贴组",
        head3: "[经办人：一级会计主任 (经常津贴 )]",
        schoolName: "学校名称",
        schoolCode: "学校代码",
        Month: "月份",
        Year: "年份",
        SSDO: "高级学校发展主任",

        vacantPostNum: "申领现金津贴的冻结空缺职位数目",
        NR: "新申领津贴的职位／修订",
        changePreclaim: "不更改先前声明／删除先前声明／更改先前声明：",
        preclaimNum: "请注明前次申领的申请编号",
        applicationNum: "申请编号",
        postRank: "申领现金津贴的冻结空缺职位所属职级",
        startDate: "可撤回的职位空缺冻结期由",
        endDate: "可撤回的职位空缺冻结期至",
        leaveStartTime: "休假时期由",
        leaveEndTime: "休假时期至",
        qualifiedStartTime: "合资格时期由",
        qualifiedEndTime: "合资格时期至",
        qualifiedMonth: "（a）合资格月数",
        monthlySalary: "（b）月薪",
        MPFSubsidy: "（c）强积金供款津贴",
        Amount: "「津贴」金额",
        amountTip:
            "「津贴」金额 = （申领现金津贴的冻结空缺职位数目 x 合资格月数（每月） x 月薪（每月） + 上限强积金供款津贴（每月））之和;",
        previousFormFile: "前次申领表格副本：",
        headerTitleThree:
            "以「津贴」代替{{postName}}放取不少于30天核準假期的临时补缺人员安排",
        // temporaryOne: "休假{{postName}}的资料",
        temporaryStaffFormTitleOne: "休假{{postName}}的资料",
        temporaryStaffFormTitleTwo: "「津贴」的资料",
        staffName: "姓名",
        SRN: "职员参考编号",
        Rank: "职级",
        MPFFile: "强积金供款证明资料：",

        absenceReason: "缺勤原因",
        total: "总计",

        signName: "校监／校长姓名",
        signDate: "日期",
        signContactPerson: "联络人",
        signTelNo: "电话号码",
        signSsdo: "高级学校发展主任",
        postNum: "职位数量",
    },
    labelStep: [
        { step: "(i)" },
        { step: "(ii)" },
        { step: "(iii)" },
        { step: "(iv)" },
    ],
    noteList: {
        STnoteOne:
            "编制数目4名以下的学校，只可把一个言语治疗师空缺职位冻结，换取现金津贴，而编制数目4名或以上的学校，最多可把两个言语治疗师空缺职位冻结，换取现金津贴；",
        noteOne: "最多可把两个{{postName}}空缺职位冻结，换取现金津贴；",
        noteTwo:
            "计算由起始日直至完结日（首尾两天包括在内）的合资格申领「津贴」月数，包含以下三个元素：",
        noteTwoA: [
            {
                text: "合资格日数在起始月份的曆日总数中所佔的比例（如适用）；",
            },
            {
                text: "完整的曆月数（如适用）；以及",
            },
            {
                text: "合资格日数在完结月份曆日总数中所佔的比例（如适用）。",
            },
        ],
        ExampleOne:
            "假设合资格申领「津贴」的时期是由二月五日至五月二十六日，计算合资格月数的方法如下：",
        noteTwoB: [
            {
                text: "起始月份的合资格日数为24日（二月五日至二月二十八日）除以28日（二月份的曆日总数）=0.857个月；",
            },
            {
                text: "由三月至四月有两个完整的曆月数；",
            },
            {
                text: "完结月份的合资格日数为26日（五月一日至二十六日）除以31日（五月份的曆日总数 ）=0.839个月；以及 ",
            },
            {
                text: "合资格申领月数应为上述三个元素的总和（计算至三个小数位），即0.857+2+0.839=3.696。",
            },
        ],
        STnoteThree:
            "填写言语治疗师的中点薪金（由二零一三／一四学年起，为总薪级表第26点）。",
        noteThreeA:
            "填写一级{{postName}}／高级{{postName}}的起薪点(如适用)。一级{{postName}}及高级{{postName}}的起薪点则分别为总薪级表第25点及34点。",
        noteThreeB:
            "填写二级{{postName}}职位的中点薪金或一级{{postName}}／高级{{postName}}的起薪点(如适用)。由二零一三／一四学年起，二级{{postName}}的中点薪金为总薪级表第19点，而一级{{postName}}及高级{{postName}}的起薪点则分别为总薪级表第25点及34点。",
        noteFour:
            "如合资格申领期达60天或以上，强积金计划僱主供款（月薪的5%，并以现行强积金规例所订的最高金额为上限）将会包括在内。如换取现金津贴的{{postName}}空缺冻结期或{{postName}}放取核准假期的临时补缺期少于60个曆日，而须向强积金供款，请提供证明资料。",
        noteFive: "填写休假的{{postName}}的职员参考编号{{rank}}。",
        noteSix: "请注意，学校必须按照教育局通告第1／2006号规定批假。",
    },
    certifyList: {
        cNote: "本人证实 –",
        cTwo: "本校已获校董会／法团校董会及大多数{{postName}}同意，在本学年上述期间冻结甲部所载的{{postName}}职位；",
        cThree: "(<i>就晋升职级 (即一级{{postName}}／高级{{postName}}</i>)的可撤回冻结空缺或临时补缺人员安排)，学校已证明有实际需要把晋升职级的可撤回冻结空缺／临时补缺人员安排转为现金津贴；",
        cFour: "冻结甲部所载的{{postName}}职位并申领「津贴」，是因为该(等)核准编制的职位在上述期间有空缺及此项申领符合“津贴”所列明的申领条件；",
        cFive: "本校没有就上述冻结期／休假 ，向政府提出其他津贴的申请；以及",
        cSix: "本校会把任何多收取的津贴退还教育局。",
    },

    errorMsg: {
        "E-0008": "输入的内容格式错误",
        leaveDateRuls: "休假期限不少于30天",
        freezDateRuls: "空缺冻结期（不少于30天）",
        freezVacancy: "可撤回的职位空缺冻结期必须为最少30历日",
        leavePeriod: "休假时期必须为最少30历日",
        qualifiedPeriod: "合资格时期必须为最少30历日",
        limitsEndDateRuls: "上述日期最迟为该学年的8月31日",
        postNumLimit: "空缺職位數目之和不能大於2 空缺职位数目之和不能大于2",
        withinLimit: "合资格时期应该在休假时期范围内",
        // qualifiedDateRules:
        //     "合资格时期（不少于30天），且截止日期不得晚于8月31日",
    },
};
export default Form054SC;
